/** @format */

/**
 * @typedef {Object} ConsumerIdentity
 * @property {string} privateName
 * @property {string} name
 * @prop {string} merchantInfoName
 * @prop {string} firstName
 * @prop {string} lastName
 * @prop {string} phone
 * @prop {string} receiptNumber
 */

const formatConsumerName2 = (consumer) => {
  const name =
    consumer.firstName ?
      consumer.merchantInfoName ? consumer.merchantInfoName
      : consumer.firstName + " " + consumer.lastName
    : ""
  // Apparently, it is somehow possible for `firstName` and `lastName` to exist
  // without `merchantInfoName` being set.

  const privateName = consumer.phone ? consumer.privateName : "";

  // NOTE: Account for bug in Linemonkey's Employee Update Consumer API that sets the `receiptNumber` to the same 
  // value as `name` if the Spot is a Numbered Spot (only has a Receipt Number).
  // Manifests if an Employee updates the Name of a Numbered Spot from the Detail Panel
  const receiptNumber = consumer.receiptNumber && !(consumer.firstName && (consumer.receiptNumber == consumer.merchantInfoName)) ? consumer.receiptNumber : "";

  // This works by generalising the pattern for showing the "Display" name.
  // Name
  // Phone
  // Ticket Number
  // Name (Phone)
  // Name (Ticket Number)
  // Name (Phone) (Ticker Number)
  // Phone (Ticket Number)
  //
  // 1. The first part does not have parentheses and all following parts are
  //    wrapped in parentheses.
  // 
  // 2. The parts have a definite priority: Name is preferred, then Private Name
  //    then Receipt Number.

  const parts = [name, privateName, receiptNumber]
    .filter((part) => Boolean(part)) // remove empty, undefined, and null parts.

  const formattedConsumerName = parts
    .reduce((formattedParts, part) => {
      return formattedParts.length == 0 ? part : `${formattedParts} (${part})`; // the first part is without parentheses, all parts after are wrapped in ()
    }, "");

  return formattedConsumerName;
};

/**
 * @param {ConsumerIdentity} consumer
 * @param {string} maskedPhoneNumber?
 * @return {string}
 */
const formatConsumerName = (consumer) => {
  // return getFormatter(determineFormat(consumer))(consumer)
  return formatConsumerName2(consumer);
};

module.exports = {
  formatConsumerName,
};
